import { Component, OnInit, Injector, ViewChild, Injectable, ElementRef } from '@angular/core';
import { AlertService } from 'src/app/Common/alert.service';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { MatPaginator as MatPaginator, PageEvent as PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { DataService } from 'src/app/Common/data.service';
import { Global } from 'src/app/Global';
import * as XLSX from 'xlsx';
import saveAs from 'file-saver';
import { CommonService } from 'src/app/shared/common.service';

@Component({
  selector: 'app-mapping-group-item',
  templateUrl: './mapping-group-item.component.html',
  styleUrls: ['./mapping-group-item.component.scss'],
  providers: [DataService]
})
export class MappingGroupItemComponent implements OnInit {
  MappingGForm: UntypedFormGroup;
  groupList: any;
  itemList: any;
  statusList: any;
  displayedColumns = ['GroupName', 'SubCategory', 'ItemName', 'Status', 'Edit', 'Delete'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  viewdata: any;
  MappingDataSource: any[];
  pageEvent: PageEvent;
  Ispanelshow: any;
  IsAddpanelshow: any;
  IsLoadingResults = false;
  @ViewChild('TABLE', { static: true }) table: ElementRef;

  constructor(public _dataservice: DataService, private _fb: UntypedFormBuilder, private error: AppErrorHandler, private status: HTTPStatus, public _global: Global, public _com: CommonService) { }

  ngOnInit() {
    this.paginator.showFirstLastButtons = true;
    this.paginator.pageSize = this._global.RecordSize;
    this.MappingGForm = this._fb.group({
      Id: [''],
      GroupId: [''],
      ItemId: [''],
      SelectedGroup: [[], Validators.required],
      SelectedItem: [[], Validators.required],
      PageNumber: (this._global.pageIndex),
      PageSize: (this._global.RecordSize),
      StatusSearch: [''],
      GroupSearch: [''],
      IsActive: [''],

    });
    this.BindGroupList();
    this.BindItemList();
    this.SearchRecord();
    this.BindStatusList();
  }

  SearchRecord() {
    this._global.pageIndex = 0;
    this._global.length = 0;
    this._global.totalPage = 0;
    this._global.RecordSize = 10;
    this.ViewDataList();
  }

  //updated by Anmol Kaur
  BindStatusList() {
    //debugger;
    this._dataservice.GetData('Category/GetStatus/').subscribe(result => {
      this.statusList = result;
    });
  }

 BindGroupList() {
    this.IsLoadingResults = true;
    this._dataservice.GetData('Category/GetGroup/').subscribe(result => {
      this.groupList = result;
      this.IsLoadingResults = false;
    });
  }
  BindItemList() {
    this._dataservice.GetData('Category/GetItem/').subscribe(result => {
      this.itemList = result;
    });
  }

  showErrorsOnInvalidForm() {
    Object.keys(this.MappingGForm.controls).forEach(field => {
      const control = this.MappingGForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  GetFormControls(controlName) {
    return this.MappingGForm.controls[controlName];
  }

  Adddata() {
    this.GetFormControls('SelectedGroup').setValidators([Validators.required]);
    this.GetFormControls('SelectedGroup').updateValueAndValidity();
    this.GetFormControls('SelectedItem').setValidators([Validators.required]);
    this.GetFormControls('SelectedItem').updateValueAndValidity();

    if (!this.MappingGForm.valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm();

      return false;
    }

    this.MappingGForm.patchValue({
      GroupId: this.MappingGForm.controls.SelectedGroup.value.GroupId,
      ItemId: this.MappingGForm.controls.SelectedItem.value.itemId,
    });
    this.status.setHttpStatus(true);
    this._dataservice.PostData('Category/AddMappingData/', this.MappingGForm.value).subscribe(result => {
      alert(result[0].MSG);
      if (result[0].STATUS == 0) {
        this.ClearData();
        this.ViewDataList();
        this.GetFormControls('SelectedGroup').clearValidators();
        this.GetFormControls('SelectedGroup').updateValueAndValidity();
        this.GetFormControls('SelectedItem').clearValidators();
        this.GetFormControls('SelectedItem').updateValueAndValidity();
      }

    }
      , (error) => {
        this.status.setHttpStatus(false);
        this.error.handleError(error);
      },
      () => { this.status.setHttpStatus(false); });
  }

  ClearData() {
    this.MappingGForm.controls.SelectedGroup.setValue('');
    this.MappingGForm.controls.SelectedItem.setValue('');
    this.MappingGForm.patchValue({
      Id: 0
    });
  }

  Relod() {
    window.location.reload();
  }

  ViewDataList() {
    this.MappingGForm.controls.PageNumber.setValue(this._global.pageIndex + 1);
    this.MappingGForm.controls.PageSize.setValue(this._global.RecordSize);
    //added by anmol kaur for search param
    let statusid =null;
    if(this.MappingGForm.controls.StatusSearch != undefined && this.MappingGForm.controls.StatusSearch != null && this.MappingGForm.controls.StatusSearch.value != undefined && this.MappingGForm.controls.StatusSearch.value != null){
      statusid = this.MappingGForm.controls.StatusSearch.value.KeywordValue;
    }
    this.MappingGForm.patchValue({
      GroupId: this.MappingGForm.controls.GroupSearch.value.GroupId,
      IsActive: statusid,
    });
    this._dataservice.PostData('Category/GetMappingList/', this.MappingGForm.value).subscribe(result => {
      this.viewdata = result;
      if (this.viewdata != null && this.viewdata.length > 0) {
        this.MappingDataSource = this.viewdata;
        this._global.length = this.viewdata[0].totalrecordcount;
        this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);

      } else {
        this.MappingDataSource = this.viewdata;
        this._global.length = 0;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 0;
        this._global.totalPage = 0;
      }
    });
  }

  onPaginateChange1(event) {
    this._global.pageIndex = event.pageIndex;
    this._global.RecordSize = event.pageSize;
    this.ViewDataList();
  }

  rowdeletedata(element) {
    if (confirm('Are you sure to want Update Status this record?')) {
      this.MappingGForm.patchValue({
        GroupId: 0,
        ItemId: 0,
        Id: element,
      });
      this.status.setHttpStatus(true);
      this._dataservice.PostData('Category/AddMappingData/', this.MappingGForm.value).subscribe(result => {
        alert(result[0].MSG);
        if (result[0].STATUS == 0) {
          this.ClearData();
          this.ViewDataList();
        }

      }
        , (error) => {
          this.status.setHttpStatus(false);
          this.error.handleError(error);
        },
        () => { this.status.setHttpStatus(false); });
    }
  }

  rowclickdata(row: any) {
    var dataitem;
    dataitem = this.MappingDataSource.filter(x => x.Id == row);
    this.MappingGForm.patchValue({
      Id: row,
      SelectedGroup: this.BindSpecialization(dataitem[0]['GroupName']),
      SelectedItem: this.BindSpecialization1(dataitem[0]['ItemName'])

    });
  }

  BindSpecialization(sf) {
    let p = this.groupList.filter(x => x.GroupName == sf);
    return p[0];
  }

  BindSpecialization1(sf) {
    let p = this.itemList.filter(x => x.ItemName == sf);
    return p[0];
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Mapping_Group_Item.xlsx');

  }

  Export() {
    this.status.setHttpStatus(true);
    this._com.ExportToExcelMappingGroup(this.MappingGForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'Mapping_Group_Item.xls');
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  ResetData() {
    this.MappingGForm.reset({
      GroupSearch: '',
      StatusSearch: '',
    });
    this.GetResult();
  }

  Exit() {

    if(this.MappingGForm.valid)
    {
        if (confirm("Are you sure you want to exit without saving changes?")) {
            //this.router.navigate(['dashboard']);
            window.history.back();
        } 
    }else{
          if (confirm("Are you sure to exit?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
    }
    }
  
    }

  GetResult() {
    this.SearchRecord();
  }

  

  showhide() {
    this.Ispanelshow = !this.Ispanelshow;
  }

  showAdd() {
    this.IsAddpanelshow = !this.IsAddpanelshow;
  }

  showhideAdd()
  {
    this.IsAddpanelshow=!this.IsAddpanelshow;
            
  }
}